export default __webpack_public_path__ + "static/media/locationIcon.088a5122.svg";